import React from "react";
//Cookie token
import cookie from "react-cookies";
//Router redirect
import { useHistory } from "react-router-dom";

const OrderTemplateCheck = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
          <h1>Check resultado Plantilla</h1>
        </>
      )}
    </>
  );
};

export default OrderTemplateCheck;
